import React, { useEffect, useRef } from "react";
import { ButtonDefault } from "@/components/Button/Button";
import containerStyles from "../WidgetContainer/WidgetContainer.module.css";
import s from "./WidgetNotAvailable.module.css";
import iconEyeClose from "@/assets/icons/iconEyeClose.svg"

const WidgetNotAvailable = ({ isMobile, onClose }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Автоматический скролл вниз при появлении
    if (containerRef.current) {
      setTimeout(() => {
        containerRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 100);
    }
  }, []);

  return (
    <div
      ref={containerRef}
      className={s.container}
    >
      <div></div>
      <div className={s.content}>
        <img src={iconEyeClose} alt="iconEyeClose" />
        <p className={s.text}>
        Данная вещь недоступна для виртуальной примерки
        </p>
      </div>
      <ButtonDefault
      variant="light"
        className={containerStyles.buttonStart}
        onClick={onClose}
      >
        Понятно
      </ButtonDefault>
    </div>
  );
};

export default WidgetNotAvailable;
